import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { bisnodeScoringChartToggleDataTable } from './actions'

function mapStateToProps(state, hocProps) {
    const { id, module, block } = hocProps

    return {
        chartDataTableActive: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'chartDataTableActive',
        ]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            bisnodeScoringChartToggleDataTable,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
